import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { message } from "antd";
import { addClassroomUrl, addProflessClassroomUrl, fetchClassroomsUrl, getSingleExerciseDataUrl, modifyClassroomUrl, pollSessionUrl, removePupilFromClassUrl, removeUserFromSessionUrl, startSessionUrl, stopSessionUrl, uploadXLSXUrl } from "../../constants";

export const classroomsSlice = createSlice({
    name: "classrooms",
    initialState: {
        classroomList: [],
        classroomListError: null,
        isFetchingClassroomList: false,
        totalClassrooms: null,

        addClassroomResult: null,
        addClassroomError: null,
        isAddingClassroom: false,

        addProflessClassroom: null,
        addProflessClassroomError: null,
        isAddingProflessClassroom: false,

        modifyClassroomResult: null,
        modifyClassroomError: null,
        isModifyingClassroom: false,

        uploadXLSXResult: null,
        uploadXLSXError: null,
        isUploadingXLSX: false,

        startSessionResult: null,
        startSessionError: null,
        isStartingSession: false,

        pollSessionResult: null,
        pollSessionError: null,
        isPollingSession: false,

        removeUserResult: null,
        removeUserError: null,
        isRemovingUser: false,

        stopSessionResult: null,
        stopSessionError: null,
        isStoppingSession: false,

        getExerciseResult: null,
        getExerciseError: null,
        isFetchingExercise: null,

        removePupilFromClassSuccess: null,
        removePupilFromClassError: null,
        isRemovingPupilFromClass: false,


    },
    reducers: {
        setClassroomList: (state, action) => {
            state.classroomList = action.payload;
            state.classroomListError = null;
            state.isFetchingClassroomList = false;
        },
        setClassroomListError: (state, action) => {
            state.classroomListError = action.payload;
            state.classroomList = [];
            state.isFetchingClassroomList = false;
        },
        setIsFetchingClassroomList: (state, action) => {
            state.isFetchingClassroomList = action.payload;
        },
        setTotalClassrooms: (state, action) => {
            state.totalClassrooms = action.payload;
        },

        setAddClassroom: (state, action) => {
            state.addClassroomResult = action.payload;
            state.addClassroomError = null;
            state.isAddingClassroom = false;
        },
        setAddClassroomError: (state, action) => {
            state.addClassroomError = action.payload;
            state.addClassroomResult = null;
            state.isAddingClassroom = false;
        },
        setIsAddingClassroom: (state, action) => {
            state.isAddingClassroom = action.payload;
        },

        setAddProflessClassroom: (state, action) => {
            state.addProflessClassroom = action.payload;
            state.addProflessClassroomError = null;
            state.isAddingProflessClassroom = false;
        },
        setAddProflessClassroomError: (state, action) => {
            state.addProflessClassroomError = action.payload;
            state.addProflessClassroom = null;
            state.isAddingProflessClassroom = false;
        },
        setIsAddingProflessClassroom: (state, action) => {
            state.isAddingProflessClassroom = action.payload;
        },

        setModifyClassroom: (state, action) => {
            state.modifyClassroomResult = action.payload;
            state.modifyClassroomError = null;
            state.isModifyingClassroom = false;
        },
        setModifyClassroomError: (state, action) => {
            state.modifyClassroomError = action.payload;
            state.modifyClassroomResult = null;
            state.isModifyingClassroom = false;
        },
        setIsModifyingClassroom: (state, action) => {
            state.isModifyingClassroom = action.payload;
        },

        setUploadXLSXResult: (state, action) => {
            state.uploadXLSXResult = action.payload;
            state.uploadXLSXError = null;
            state.isUploadingXLSX = false;
        },
        setUploadXLSXError: (state, action) => {
            state.uploadXLSXError = action.payload;
            state.uploadXLSXResult = null;
            state.isUploadingXLSX = false;
        },
        setIsUploadingXLSX: (state, action) => {
            state.isUploadingXLSX = action.payload;
        },

        setStartSessionSuccess: (state, action) => {
            state.startSessionResult = action.payload;
            state.startSessionError = null;
            state.isStartingSession = false;
        },
        setStartSessionError: (state, action) => {
            state.startSessionError = action.payload;
            state.startSessionResult = null;
            state.isStartingSession = false;
        },
        setIsStartingSession: (state, action) => {
            state.isStartingSession = action.payload;
        },

        setPollSessionSuccess: (state, action) => {
            state.pollSessionResult = action.payload;
            state.pollSessionError = null;
            state.isPollingSession = false;
        },
        setPollSessionError: (state, action) => {
            state.pollSessionError = action.payload;
            state.pollSessionResult = null;
            state.isPollingSession = false;
        },
        setIsPollingSession: (state, action) => {
            state.isPollingSession = action.payload;
        },
        
        setRemoveUserSuccess: (state, action) => {
            state.removeUserResult = action.payload;
            state.removeUserError = null;
            state.isRemovingUser = false;
        },
        setRemoveUserError: (state, action) => {
            state.removeUserError = action.payload;
            state.removeUserResult = null;
            state.isRemovingUser = false;
        },
        setIsRemovingUser: (state, action) => {
            state.isRemovingUser = action.payload;
        },

        setStopSessionSuccess: (state, action) => {
            state.stopSessionResult = action.payload;
            state.stopSessionError = null;
            state.isStoppingSession = false;
        },
        setStopSessionError: (state, action) => {
            state.stopSessionError = action.payload;
            state.stopSessionResult = null;
            state.isStoppingSession = false;
        },
        setIsStoppingSession: (state, action) => {
            state.isStoppingSession = action.payload;
        },
        
        setGetExerciseResult: (state, action) => {
            state.getExerciseResult = action.payload;
            state.getExerciseError = null;
            state.isFetchingExercise = false;
        },
        setGetExerciseError: (state, action) => {
            state.getExerciseError = action.payload;
            state.getExerciseResult = null;
            state.isFetchingExercise = false;
        },
        setIsFetchingExercise: (state, action) => {
            state.isFetchingExercise = action.payload;
        },
        
        setRemovePupilFromClassSuccess: (state, action) => {
            state.removePupilFromClassSuccess = action.payload;
            state.removePupilFromClassError = null;
            state.isRemovingPupilFromClass = false;
        },
        setRemovePupilFromClassError: (state, action) => {
            state.removePupilFromClassError = action.payload;
            state.removePupilFromClassSuccess = null;
            state.isRemovingPupilFromClass = false;
        },
        setIsRemovingPupilFromClass: (state, action) => {
            state.isRemovingPupilFromClass = action.payload;
        },
    }
});

export const {
    setClassroomList,
    setClassroomListError,
    setIsFetchingClassroomList,
    setTotalClassrooms,

    setAddClassroom,
    setAddClassroomError,
    setIsAddingClassroom,

    setAddProflessClassroom,
    setAddProflessClassroomError,
    setIsAddingProflessClassroom,

    setModifyClassroom,
    setModifyClassroomError,
    setIsModifyingClassroom,

    setUploadXLSXResult,
    setUploadXLSXError,
    setIsUploadingXLSX,

    setStartSessionSuccess,
    setStartSessionError,
    setIsStartingSession,

    setPollSessionSuccess,
    setPollSessionError,
    setIsPollingSession,

    setRemoveUserSuccess,
    setRemoveUserError,
    setIsRemovingUser,

    setStopSessionSuccess,
    setStopSessionError,
    setIsStoppingSession,

    setGetExerciseResult,
    setGetExerciseError,
    setIsFetchingExercise,

    setRemovePupilFromClassSuccess,
    setRemovePupilFromClassError,
    setIsRemovingPupilFromClass,

} = classroomsSlice.actions;

export const fetchClassroomList = (cookies, data) => (dispatch, getState) => {
    const config = {
        method: "post",
        url: fetchClassroomsUrl,
        headers: {
            "Content-Type": "application/json",
            Authorization: cookies.proftoken,
        },
        data
    };

    dispatch(setIsFetchingClassroomList(true));
    const response = axios(config)
        .then((response) => {
            dispatch(setClassroomList(response.data?.classrooms));
            dispatch(setTotalClassrooms(response.data?.classroomCount))
        })
        .catch((response) => {
            message.error(response.response?.data?.message);
            dispatch(setClassroomListError(response.message));
        });


    return response.data;
}

export const addClassroom = (cookies, data) => (dispatch, getState) => {
    const config = {
        method: "post",
        url: addClassroomUrl,
        headers: {
            "Content-Type": "application/json",
            Authorization: cookies.proftoken,
        },
        data
    };

    dispatch(setIsAddingClassroom(true));
    const response = axios(config)
        .then((response) => {
            dispatch(setAddClassroom(response.data));
        })
        .catch((response) => {
            message.error(response.response?.data?.message);
            dispatch(setAddClassroomError(response.message));
        });


    return response.data;
}

export const addProflessClassroom = (cookies, data) => (dispatch, getState) => {
    const config = {
        method: "post",
        url: addProflessClassroomUrl,
        headers: {
            "Content-Type": "application/json",
            Authorization: cookies.proftoken,
        },
        data
    };

    dispatch(setIsAddingProflessClassroom(true));
    const response = axios(config)
        .then((response) => {
            dispatch(setAddProflessClassroom(response.data?.classroom));
        })
        .catch((response) => {
            message.error(response.response?.data?.message);
            dispatch(setAddProflessClassroomError(response.message));
        });


    return response.data;
}

export const modifyClassroom = (cookies, data) => (dispatch, getState) => {
    const config = {
        method: "post",
        url: modifyClassroomUrl,
        headers: {
            "Content-Type": "application/json",
            Authorization: cookies.proftoken,
        },
        data
    };

    dispatch(setIsModifyingClassroom(true));
    const response = axios(config)
        .then((response) => {
            dispatch(setModifyClassroom(response.data));
        })
        .catch((response) => {
            message.error(response.response?.data?.message);
            dispatch(setModifyClassroomError(response.message));
        });


    return response.data;
}

export const UploadXLSX = (cookies, data, file) => (dispatch, getState) => {
    let formData = new FormData();
    formData.append("document", file);
    formData.append("folder_path", data.folder_path);
    console.log(uploadXLSXUrl);
    const config = {
        method: "post",
        url: uploadXLSXUrl,
        headers: {
            "Content-Type": "multipart/form-data",
            Authorization: cookies.proftoken,
        },
        data: formData
    };

    setIsUploadingXLSX(true);
    const response = axios(config)
        .then((response) => {
            dispatch(setUploadXLSXResult(response.data));
        })
        .catch((response) => {
            dispatch(setUploadXLSXError(response.response.data.message));
            message.error(response.response.data.message);
        });
    
    return response.data;
}

export const StartSession = (cookies, data) => (dispatch, getState) => {
    const config = {
        method: "post",
        url: startSessionUrl,
        headers: {
            "Content-Type": "application/json",
            Authorization: cookies.proftoken,
        },
        data
    };
    dispatch(setIsStartingSession(true));
    const response = axios(config)
        .then((response) => {
            dispatch(setStartSessionSuccess(response.data));
        })
        .catch((response) => {
            message.error(response.response?.data?.message);
            dispatch(setStartSessionError(response.message));
        });


    return response.data;
}

export const PollSession = (cookies, data) => (dispatch, getState) => {
    const config = {
        method: "post",
        url: pollSessionUrl,
        headers: {
            "Content-Type": "application/json",
            Authorization: cookies.proftoken,
        },
        data
    };
    dispatch(setIsPollingSession(true));
    const response = axios(config)
        .then((response) => {
            dispatch(setPollSessionSuccess(response.data));
        })
        .catch((response) => {
            message.error(response.response?.data?.message);
            dispatch(setPollSessionError(response.message));
        });


    return response.data;
}

export const StopSession = (cookies, data) => (dispatch, getState) => {
    const config = {
        method: "post",
        url: stopSessionUrl,
        headers: {
            "Content-Type": "application/json",
            Authorization: cookies.proftoken,
        },
        data
    };

    dispatch(setIsStoppingSession(true));
    const response = axios(config)
        .then((response) => {
            dispatch(setStopSessionSuccess(response.data));
        })
        .catch((response) => {
            message.error(response.response?.data?.message);
            dispatch(setStopSessionError(response.message));
        });


    return response.data;
}

export const fetchExercise = (cookies, data) => (dispatch, getState) => {
    const config = {
        method: "post",
        url: getSingleExerciseDataUrl,
        headers: {
            "Content-Type": "application/json",
            Authorization: cookies.proftoken,
        },
        data
    };

    dispatch(setIsFetchingExercise(true));
    const response = axios(config)
        .then((response) => {
            dispatch(setGetExerciseResult(response.data));
        })
        .catch((response) => {
            message.error(response.response?.data?.message);
            dispatch(setGetExerciseError(response.message));
        });


    return response.data;
}

export const RemoveUserFromSession = (cookies, data) => (dispatch, getState) => {
    const config = {
        method: "post",
        url: removeUserFromSessionUrl,
        headers: {
            "Content-Type": "application/json",
            Authorization: cookies.proftoken,
        },
        data
    };

    dispatch(setIsRemovingUser(true));
    const response = axios(config)
        .then((response) => {
            message.success(response.data.message);
            dispatch(setRemoveUserSuccess(response.data));
        })
        .catch((response) => {
            message.error(response.response?.data?.message);
            dispatch(setRemoveUserError(response.message));
        });


    return response.data;
}

export const RemovePupilFromClass = (cookies, data) => (dispatch, getState) => {
    const config = {
        method: "post",
        url: removePupilFromClassUrl,
        headers: {
            "Content-Type": "application/json",
            Authorization: cookies.proftoken,
        },
        data
    };

    dispatch(setIsRemovingPupilFromClass(true));
    const response = axios(config)
        .then((response) => {
            message.success(response.data.message);
            dispatch(setRemovePupilFromClassSuccess(response.data));
        })
        .catch((response) => {
            message.error(response.response?.data?.message);
            dispatch(setRemovePupilFromClassError(response.message));
        });


    return response.data;
}

export default classroomsSlice.reducer;